import { useEffect, useState } from 'react';
import { useAccount, useReadContract, useWaitForTransactionReceipt, useWriteContract } from 'wagmi';
import { getContractABIBuy, getContractBuyAddress } from '../helpers/web3utils';
import { ethers } from 'ethers';
import toast from '../libs/toast';

export const useClaimToken = (callback) => {
  const { address } = useAccount();
  const { isPending, writeContractAsync, data } = useWriteContract();
  const { isLoading: isLoadingTrans, data: dataTrans } = useWaitForTransactionReceipt({
    hash: data
  });
  useEffect(() => {
    if (data && !isLoadingTrans && dataTrans?.status === 'success') {
      callback();
    }
  }, [isLoadingTrans]);
  async function handleClaim() {
    await toast.promise(async () => {
      // contract.buyToken(
      //   refCode && refCode !== address && ethers.isAddress(refCode)
      //     ? refCode
      //     : ethers.ZeroAddress,
      //   ethers.parseEther(amountToken.toString()),
      //   options
      // )

      return writeContractAsync({
        abi: getContractABIBuy(),
        address: getContractBuyAddress(),
        functionName: 'claimToken',
        args: []
      });
    });
  }
  return { isPending: isLoadingTrans, handleClaim };
};
export const useClaimCommissionToken = (callback) => {
  const { address } = useAccount();
  const { isPending, writeContractAsync, data } = useWriteContract();
  const { isLoading: isLoadingTrans, data: dataTrans } = useWaitForTransactionReceipt({
    hash: data
  });
  useEffect(() => {
    if (data && !isLoadingTrans && dataTrans?.status === 'success') {
      callback && callback();
    }
  }, [isLoadingTrans]);
  async function handleClaim() {
    await toast.promise(async () => {
      // contract.buyToken(
      //   refCode && refCode !== address && ethers.isAddress(refCode)
      //     ? refCode
      //     : ethers.ZeroAddress,
      //   ethers.parseEther(amountToken.toString()),
      //   options
      // )
      return writeContractAsync({
        abi: getContractABIBuy(),
        address: getContractBuyAddress(),
        functionName: 'claimCommission',
        args: []
      });
    });
  }
  return { isPending: isLoadingTrans, handleClaim };
};
export const useTotalBuy = (address) => {
  return useReadContract({
    abi: getContractABIBuy(),
    address: getContractBuyAddress(),
    functionName: 'totalBuy',
    args: [address]
  });
};
export const useTotalCommission = (address) => {
  return useReadContract({
    abi: getContractABIBuy(),
    address: getContractBuyAddress(),
    functionName: 'totalCommission',
    args: [address]
  });
};
export const useCanClaimPercent = () => {
  return useReadContract({
    abi: getContractABIBuy(),
    address: getContractBuyAddress(),
    functionName: 'canClaimPercent',
    args: []
  });
};
export const useTotalTokenClaim = (address) => {
  return useReadContract({
    abi: getContractABIBuy(),
    address: getContractBuyAddress(),
    functionName: 'totalTokenClaim',
    args: [address]
  });
};
export const useTotalClaimRef = (address) => {
  return useReadContract({
    abi: getContractABIBuy(),
    address: getContractBuyAddress(),
    functionName: 'totalClaimRef',
    args: [address]
  });
};
